// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11OnA","right":"styles_right__2qDrx"};